import React from 'react';

const ZazuLogo = ({ size = 'md', showText = true, className = '' }) => {
  const sizes = {
    sm: { img: 32, text: 'text-lg' },
    md: { img: 40, text: 'text-xl' },
    lg: { img: 56, text: 'text-2xl' },
    xl: { img: 72, text: 'text-3xl' }
  };
  
  const s = sizes[size] || sizes.md;
  
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="zazu-logo">
      <img 
        src="/zippy/zippy-head.png"
        alt="Zazu - Learning Made Fun"
        className="object-contain"
        style={{ width: s.img, height: s.img }}
      />
      {showText && (
        <span className={`font-fredoka font-bold bg-gradient-to-r from-emerald-500 via-teal-500 to-amber-500 bg-clip-text text-transparent ${s.text}`}>
          Zazu
        </span>
      )}
    </div>
  );
};

export default ZazuLogo;
